import { useContent } from "@/context/ContentContext";
import { SOCIALS, WhatsAppIcon } from "@/components/SocialIcons";

export default function Floating({ revealed = true }) {
  const c = useContent();
  const socials = c.socials || {};
  const whatsapp = c.contact?.whatsapp;
  const chrome = revealed ? "" : "site-chrome-hidden";

  return (
    <>
      <div
        data-testid="floating-social-bar"
        className={`site-chrome fixed top-1/2 left-4 z-40 hidden -translate-y-1/2 flex-col gap-2 lg:flex ${chrome}`}
      >
        {SOCIALS.filter((s) => socials[s.key]).map(({ key, label, Icon }) => (
          <a
            key={key}
            href={socials[key]}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`floating-social-${key}`}
            aria-label={label}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-black/50 text-white/65 backdrop-blur-md transition-all duration-300 select-none hover:border-crimson hover:text-crimson"
          >
            <Icon size={15} />
          </a>
        ))}
      </div>
      {whatsapp && (
        <a
          href={`https://wa.me/${whatsapp.replace(/\D/g, "")}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp-button"
          aria-label="Chat on WhatsApp"
          className={`site-chrome fixed right-5 bottom-5 z-40 flex h-13 w-13 items-center justify-center rounded-full bg-[#25D366] p-3.5 text-black shadow-[0_0_30px_rgba(37,211,102,0.35)] transition-transform duration-300 select-none hover:scale-110 max-sm:h-11 max-sm:w-11 max-sm:p-3 ${chrome}`}
        >
          <WhatsAppIcon size={24} />
        </a>
      )}
    </>
  );
}
